import type { StaticDatabase } from "@-/dev.improve.haniverse.database.static";
import type { UnpackedGraphemeStrokes } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.strokes";
import { hasLength } from "@-/com.npmjs.ts-array-length";

export type SlideSvgGlyphStroke = {
  median: readonly [number, number][];
  path: string;
};

/**
 * Loads Hanzi Writer stroke outlines + medians for the given glyphs from the static database.
 * Missing glyphs are omitted from the result (callers treat that as "no stroke data").
 */
export async function fetchSlideSvgGlyphStrokes(
  staticDb: StaticDatabase,
  glyphs: readonly string[],
): Promise<Readonly<Record<string, readonly SlideSvgGlyphStroke[]>>> {
  if (hasLength(glyphs, 0)) {
    return {};
  }

  const rows = await staticDb(import.meta.location).query.grapheme.findMany({
    columns: { glyph: true },
    where: { glyph: { in: [...glyphs] } },
    with: { strokeData: { columns: { strokeData: true } } },
  });

  const out: Record<string, readonly SlideSvgGlyphStroke[]> = {};
  for (const row of rows) {
    out[row.glyph] = (row.strokeData?.strokeData ?? []).map(
      ({ medians, path }: UnpackedGraphemeStrokes) => ({
        median: medians,
        path,
      }),
    );
  }
  return out;
}
